import * as React from "react";
import type { SVGProps } from "react";
const SvgProfileTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={81}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M40.763 6.667c-8.733 0-15.833 7.1-15.833 15.833 0 8.567 6.7 15.5 15.433 15.8.267-.033.533-.033.733 0h.234c8.533-.3 15.233-7.233 15.266-15.8 0-8.733-7.1-15.833-15.833-15.833Z"
    />
    <path
      fill="#fff"
      d="M57.696 47.2c-9.3-6.2-24.467-6.2-33.833 0-4.234 2.8-6.567 6.633-6.567 10.733 0 4.1 2.333 7.9 6.533 10.7 4.667 3.134 10.8 4.7 16.934 4.7 6.133 0 12.266-1.566 16.933-4.7 4.2-2.833 6.533-6.633 6.533-10.766-.033-4.067-2.333-7.9-6.533-10.667Z"
      opacity={0.4}
    />
    <path
      fill="#fff"
      d="M38.663 64.2c-.533 0-1.066-.233-1.466-.6l-4.2-4.2c-.8-.8-.8-2.133 0-2.933.8-.8 2.133-.8 2.933 0l2.733 2.733 6.934-6.933c.8-.8 2.133-.8 2.933 0 .8.8.8 2.133 0 2.933l-8.4 8.4c-.4.4-.934.6-1.467.6Z"
    />
  </svg>
);
export default SvgProfileTick;
